import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSItemService from '@/services/SistemaDKP/SLSItem.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const slsItemsService = new SLSItemService();
  const refItemsListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'item_id', label: 'ID', sortable: false },
    { key: 'item_descricao', label: 'Descrição', sortable: true },
    { key: 'item_situacao', label: 'Situação', sortable: true },
    { key: 'grupo_estoque', label: 'Grupo Estoque', sortable: true },
    {
      key: 'familia_comercial',
      label: 'Família Comercial',
      sortable: true,
    },
    { key: 'familia_material', label: 'Família Material', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalItems = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('item_id');
  const isSortDirDesc = ref(true);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refItemsListTable.value ? refItemsListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalItems.value,
    };
  });

  const refetchData = () => {
    refItemsListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const fetchItems = (ctx, callback) => {
    overlay.value = true;
    slsItemsService.findAll({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      callback(data);
      overlay.value = false;
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalItems.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    try {
      await slsItemsService.createItem(body);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Produto cadastrado com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      refetchData();
    } catch (error) {
      console.error('Erro ao cadastrar Produto.');
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: 'Erro ao cadastrar Produto.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
  };

  const removerProduto = async (id) => {
    await slsItemsService.destroy(id);
    refetchData();
  };

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchItems,
    tableColumns,
    perPage,
    currentPage,
    totalItems,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refItemsListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    removerProduto,

    // Extra Filters
    statusFilter,
  };
}
